import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import FlexView from "react-flexview";
import DataGrid from "../../../../../../shared/components/Grid";
import { resetFilters } from "../../../../../../shared/components/Grid/functions/filters";
// import DataGrid from "../../../../../shared/components/Grid";
// import {initialColsSelector, onChangeColumns} from "../../../../../shared/components/Grid/functions";
import { getColumnDefs } from "./columnDefs";
import { useLanguage } from "../../../../../../shared/hooks/Language";

export interface Props {
  data: any;
  agrupacionData: any,//'Sociedad' | 'Dn' | 'GrupoFactura' | 'Usuario'
  rolPermiso:string,
  style?: any;
  onSelected?(selected: any): any;
	onChange?(row: any): any;
  ref?: any;
  large?:boolean | undefined;
}

export const GridResultsScreen = forwardRef((props:Props, ref:any) => {

  const {translate} = useLanguage();

  let { data, agrupacionData, rolPermiso, style, onSelected, onChange,large} = props;
  let columnDefs = getColumnDefs(translate, {agrupacion:agrupacionData,rolPermiso:rolPermiso});
  let [api, setApi] = useState(undefined)

  const onSelection = (api: any, selected: any) => {
		onSelected && onSelected(selected);
  };

  const onRowValueChanged = (api: any, event: any) => {
		onChange && onChange(event.data);
  };

  useImperativeHandle(
    ref,
    () => ({
        onFilterClear(){
          api && resetFilters(api)
        }
     })
  )

  const updateApi = (api:any) =>{
    setApi(api)
  }

    return (
      <FlexView grow column>
        <DataGrid
        data={data}
        columnDefs={columnDefs}
        className={`grid-facturacion ${large&&large===true?'large':''}`}
        menu={false}
        selector={false}
        floatingFilter
        fileExportName=""
        onSelectionChanged={onSelection}
        onRowValueChanged={onRowValueChanged}
        suppressRowClickSelection={true}
        updateApi={updateApi}
        translate={translate}
        />
      </FlexView>
    );
})